import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

/**
 * A password <input> with a show/hide eye toggle. Drop-in — takes the same
 * props as <input> (value, onChange, required, minLength, placeholder, …)
 * plus an optional className for the wrapper.
 */
const PasswordInput = ({ className = "", inputClassName = "", ...inputProps }) => {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        {...inputProps}
        type={show ? "text" : "password"}
        className={`w-full px-3.5 py-2.5 pr-10 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition ${inputClassName}`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
      >
        {show ? <FiEyeOff size={16} /> : <FiEye size={16} />}
      </button>
    </div>
  );
};

export default PasswordInput;
